export const getDateByOption = (optionValue) => {
  const now = new Date();
  let startDate = null;
  let endDate = new Date(now);

  // Normalize end date to end of day
  endDate.setHours(23, 59, 59, 999);

  switch (optionValue) {
    // Today
    case 1: {
      startDate = new Date(now);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // Yesterday
    case 2: {
      startDate = new Date(now);
      startDate.setDate(startDate.getDate() - 1);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(startDate);
      endDate.setHours(23, 59, 59, 999);
      break;
    }

    // This Week (Monday → today)
    case 3: {
      const day = now.getDay(); // 0 = Sunday
      const diff = day === 0 ? 6 : day - 1; // make Monday first day

      startDate = new Date(now);
      startDate.setDate(now.getDate() - diff);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // Last Week (Monday → Sunday)
    case 4: {
      const day = now.getDay();
      const diff = day === 0 ? 6 : day - 1;

      startDate = new Date(now);
      startDate.setDate(now.getDate() - diff - 7);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);
      break;
    }

    // Fortnight (Last 15 days including today)
    case 5: {
      startDate = new Date(now);
      startDate.setDate(now.getDate() - 14);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // This Month
    case 6: {
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // Last Month
    case 7: {
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(now.getFullYear(), now.getMonth(), 0);
      endDate.setHours(23, 59, 59, 999);
      break;
    }

    // Last 3 Months (rolling)
    case 8: {
      startDate = new Date(now);
      startDate.setMonth(now.getMonth() - 3);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // Last 6 Months (rolling)
    case 9: {
      startDate = new Date(now);
      startDate.setMonth(now.getMonth() - 6);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // This Year
    case 10: {
      startDate = new Date(now.getFullYear(), 0, 1);
      startDate.setHours(0, 0, 0, 0);
      break;
    }

    // Last Year
    case 11: {
      startDate = new Date(now.getFullYear() - 1, 0, 1);
      startDate.setHours(0, 0, 0, 0);

      endDate = new Date(now.getFullYear() - 1, 11, 31);
      endDate.setHours(23, 59, 59, 999);
      break;
    }

    // Custom Range
    case 12: {
      return null; // Indicates user should select custom dates
    }

    // Single Date (Today) - for single date picker
    case 13: {
      const today = new Date(now);
      today.setHours(0, 0, 0, 0);
      return today;
    }

    // Single Date (Yesterday) - for single date picker
    case 14: {
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      return yesterday;
    }

    default:
      return null;
  }

  return { startDate, endDate };
};
